module.exports = __webpack_public_path__ + "img/infographicWhoWeAreVerticalHome.024c34a2.webp";